import { ValueObject } from '../../../shared/models/ValueObject';

/**
 * 전화번호 값 객체
 */
export class Phone extends ValueObject<string> {
  private readonly _value: string;

  constructor(value: string) {
    super();
    const normalized = this.normalize(value);
    this.validate(normalized);
    this._value = normalized;
  }

  get value(): string {
    return this._value;
  }

  /**
   * 표시용 포맷
   */
  get formatted(): string {
    const cleaned = this._value.replace(/\D/g, '');
    if (cleaned.length === 11) {
      return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 7)}-${cleaned.slice(7)}`;
    }
    if (cleaned.length === 10) {
      return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    }
    return this._value;
  }

  private normalize(value: string): string {
    // 숫자만 추출
    return value.replace(/\D/g, '');
  }

  private validate(value: string): void {
    if (!value) {
      throw new Error('전화번호는 비어있을 수 없습니다');
    }

    // 한국 휴대폰 번호 검증 (010, 011, 016, 017, 018, 019)
    const mobileRegex = /^01[0-9]{8,9}$/;
    if (!mobileRegex.test(value)) {
      throw new Error('올바른 휴대폰 번호 형식이 아닙니다');
    }
  }

  protected equalsCore(vo: Phone): boolean {
    return this._value === vo._value;
  }

  protected copy(): Phone {
    return new Phone(this._value);
  }

  toString(): string {
    return this.formatted;
  }

  /**
   * 팩토리 메서드
   */
  static create(value: string): Phone {
    return new Phone(value);
  }
}